import { CAS_CDP_REGWALL_ID } from "@helper/getEnvVariables";
import { isArrayWithElements } from "@helper/utils";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import ArticleElementWrapper from "@pages/Article/Components/ArticleElementWrapper";

import CASBlock from "../../CASBlock/CASBlock";
import AttachmentCard from "../AttachmentCard/AttachmentCard";
import DraggableCTA from "../DraggableCTA/DraggableCTA";
import RelatedArticle from "../RelatedArticle/RelatedArticle";
import RelatedArticleNew from "../RelatedArticle/RelatedArticleNew";
import { RenderTags } from "../Typography/Tags";
import { ArticleParagraphProps } from "./ArticleParagraph";

type PostContentSectionProps = Pick<
  ArticleParagraphProps,
  | "relatedArticles"
  | "attachments"
  | "isInfiniteScrollArticle"
  | "newDesign"
  | "tags"
  | "pageNumber"
  | "articleSlotTarget"
  | "visibleArticleId"
  | "gsChannels"
> & {
  translatedArticle: ProcessedArticleData | undefined;
  isCasScriptReady: boolean;
};

export function PostContentSection(props: PostContentSectionProps) {
  const {
    newDesign,
    attachments,
    isInfiniteScrollArticle,
    relatedArticles,
    tags,
    pageNumber,
    articleSlotTarget,
    visibleArticleId,
    gsChannels,
    isCasScriptReady,
    translatedArticle,
  } = props;
  const casBlockProps = {
    key: `cas-${CAS_CDP_REGWALL_ID}`,
    casId: CAS_CDP_REGWALL_ID,
    ...(isInfiniteScrollArticle && { index: pageNumber }),
  };
  return (
    <>
      {newDesign && (
        <ArticleElementWrapper>
          {isArrayWithElements(attachments) && (
            <div className="my-6 lg:my-8 flex flex-col gap-3">
              {attachments.map((attachment, idx) => (
                <AttachmentCard
                  key={idx}
                  attachment={attachment}
                  newDesign={true}
                />
              ))}
            </div>
          )}

          {isArrayWithElements(relatedArticles) && (
            <div className="my-6 lg:my-8">
              <RelatedArticleNew relatedArticles={relatedArticles} />
            </div>
          )}

          <RenderTags
            tagsWrapper="my-6 lg:my-8 gap-[10px]"
            tags={tags}
            tagClass="bg-grey-1000 px-[10px] py-[3px] not-italic text-[12px] lg:text-[12px] leading-[150%] text-grey-350"
          />
        </ArticleElementWrapper>
      )}
      {isArrayWithElements(relatedArticles) && !newDesign && (
        <ArticleElementWrapper>
          <RelatedArticle relatedArticles={relatedArticles} />
        </ArticleElementWrapper>
      )}
      {isCasScriptReady && (
        <ArticleElementWrapper>
          <CASBlock className="mt-md" {...casBlockProps} />
        </ArticleElementWrapper>
      )}
      {translatedArticle && (
        <DraggableCTA
          pageNumber={pageNumber}
          translatedArticle={translatedArticle}
          articleSlotTarget={articleSlotTarget}
          gsChannels={gsChannels}
          isInfiniteScrollArticle={isInfiniteScrollArticle}
          visibleArticleId={visibleArticleId}
          newDesign={newDesign}
        />
      )}
    </>
  );
}
